//#endregion
//#region Utilities
export var FileKind;
(function (FileKind) {
  FileKind[FileKind["FILE"] = 0] = "FILE";
  FileKind[FileKind["FOLDER"] = 1] = "FOLDER";
  FileKind[FileKind["ROOT_FOLDER"] = 2] = "ROOT_FOLDER";
})(FileKind || (FileKind = {}));
//#endregion